import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'AppLogo'; // Adjust the URL based on your actual API's URL

// Fetch the current app logo
const getAppLogo = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}`, {
            // headers: {
            //     'Authorization': `Bearer ${token}`
            // }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch app logo:', error);
        throw error;
    }
};

// Update the app logo
const updateAppLogo = async (formData, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to update app logo:', error);
        throw error;
    }
};

// Remove the app logo
const removeAppLogo = async (token) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to remove app logo:', error);
        throw error;
    }
};

export const AppLogoDataService = {
    getAppLogo,
    updateAppLogo,
    removeAppLogo
};
